import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { AnalyticsPermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  perm: string | readonly string[],
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Analytics route page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(perm, Page) }
}

/** Admin analytics routes under /admin/analytics. */
export const analyticsRoutes: RouteObject[] = [
  {
    path: 'admin/analytics',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/analytics-page'),
        'AnalyticsPage',
        AnalyticsPermissions.access,
      ),
  },
]
